import React, {useMemo} from 'react';

import {Localization} from '#core/localization.js';

import {constructTilePalette} from '#core/application/modules/tiles-cache.js';
import {BasePalette} from '#core/application/modules/base-palette.js';

// eslint-disable-next-line react/prop-types
const Message = ({message}) => {
    const messageStyle = useMemo(() => {
        const emptyContentMessageTile = constructTilePalette(
            'EMPTY_CONTENT_MESSAGE',
            null,
            BasePalette.palette.FILL_CONTENT_DEFAULT
        );

        return {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 64,
            fontFamily: BasePalette.palette.FONT_FAMILY,
            ...emptyContentMessageTile.EMPTY_CONTENT_MESSAGE_TEXT,
        };
    }, []);

    return <div style={messageStyle}>{message}</div>;
};

export const NotAuthenticatedMessage = () => (
    <Message message={Localization.getTranslation('$DBX.COMMON.NOT_AUTHENTICATED')} />
);
